import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import History from "./History";
import ReadOnlyPackage from "./ReadOnlyPackage";
import { useNavigate, useLocation } from "react-router-dom";


const ViewPackage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const CurrentTab = parseInt(sessionStorage.getItem("ViewServiceTab"));
  const location = useLocation();
  const user_id = JSON.parse(localStorage.getItem("details")).id;
  const token = localStorage.getItem("token");
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const [currantTab, setCurrantTab] = useState(CurrentTab || 1);


  const tabs = [
    { value: 1, name: "Information" },
    { value: 2, name: "History" },
  ];

  return (
    <div className="view-package">
      <>
        <div className="row mb-3">
          <div className="col">
            <h4 className="page-title">
              <button className="btn p-0 fs-5" onClick={() => { window.history.back(); sessionStorage.removeItem("ViewServiceTab") }}>
                <i className="bx bx-arrow-back text-pink"></i>
              </button> Package
              <span>
                <i className=" ri-arrow-right-s-line"></i> {location?.state?.row?.name || ""}
              </span>
            </h4>
          </div>
        </div>

        <ul className="nav nav-tabs nav-tabs-bordered"  >
          {tabs.map((tab) => (
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${currantTab == tab.value ? "active" : ""}`}
                id={`${tab.name}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#bordered-${tab.name}`}
                type="button"
                role="tab"
                aria-controls="information"
                aria-selected="true"
                onClick={() => {
                  setCurrantTab(tab.value)
                  sessionStorage.setItem("ViewServiceTab", tab.value)
                }}
              >
                {tab.name}
              </button>
            </li>
          ))}
        </ul>
        <div className="tab-content pt-4" id="borderedTabContent">
          <div className={`tab-pane fade ${currantTab == 1 ? 'show active' : ""}`}  >
            <ReadOnlyPackage />
          </div>

          <div className={`tab-pane fade ${currantTab == 2 ? 'show active' : ""}`} >
            <History />
          </div>
        </div>
      </>
    </div>
  );
};

export default ViewPackage;
